import * as Actions from './VirtualEventsActions';
import { normalizeVirtualEvents } from './VirtualEventsUtils';
import { getDifference, isArrayEqual } from '../../Utils/ArrayUtils';
import { MAX_RANGE, MIN_RANGE, MAX_VE_SELECTED } from '../../Utils/Constants';
import { isInRange } from '../../Utils/MathUtils';
const initialState = {
  fetching: false,
  virtualEvents: {
    byKey: {},
    allKeys: [],
    deSelectedKeys: [],
    filteredKeys: [],
    filteredSelectedVirtualEventKeys: []
  },
  filter: {
    searchString: '',
    fromTime: null,
    toTime: null,
    registrantRange: [MIN_RANGE, MAX_RANGE]
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_VIRTUAL_EVENTS_REQUEST: {
      return {
        ...state,
        filter: {
          ...state.filter,
          fromTime: action.payload.fromTime,
          toTime: action.payload.toTime
        },
        fetching: true,
        error: null
      };
    }
    case Actions.GET_VIRTUAL_EVENTS_SUCCESS: {
      const virtualEventsList = action.payload.virtualEventsList || [];
      const { allKeys, byKey } = normalizeVirtualEvents(virtualEventsList);
      const {
        searchString = state.filter.searchString,
        registrantRange = state.filter.registrantRange
      } = action.payload;
      const newFilteredKeys = getFilteredVirtualEventKeys(allKeys, byKey, searchString, registrantRange);

      const deSelect = getDifference(newFilteredKeys, state.virtualEvents.filteredSelectedVirtualEventKeys);
      const select = getDifference(newFilteredKeys, deSelect);
      return {
        ...state,
        fetching: false,
        virtualEvents: {
          ...state.virtualEvents,
          byKey,
          allKeys,
          filteredKeys: newFilteredKeys,
          deSelectedKeys: deSelect,
          filteredSelectedVirtualEventKeys: select
        }
      };
    }
    case Actions.GET_VIRTUAL_EVENTS_FAILURE:
      return { ...state, ...initialState, fetching: false, error: action.error };
    case Actions.TOGGLE_VIRTUAL_EVENT: {
      const { virtualEventKey, isSelected } = action.payload;
      const { allKeys } = state.virtualEvents;
      const filteredSelectedVirtualEventKeys = [...state.virtualEvents.filteredSelectedVirtualEventKeys];
      if (isSelected) {
        filteredSelectedVirtualEventKeys.push(virtualEventKey);
      } else {
        const index = filteredSelectedVirtualEventKeys.findIndex(eventKey => eventKey === virtualEventKey);
        filteredSelectedVirtualEventKeys.splice(index, 1);
      }
      const newDeSelectedKeys = allKeys.filter(key => filteredSelectedVirtualEventKeys.indexOf(key) === -1);

      return {
        ...state,
        virtualEvents: {
          ...state.virtualEvents,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedVirtualEventKeys
        }
      };
    }
    case Actions.RESET_FILTER_SELECTED_VIRTUAL_EVENT_KEY: {
      return {
        ...state,
        virtualEvents: {
          ...state.virtualEvents,
          filteredSelectedVirtualEventKeys: [],
          deSelectedKeys: [...state.virtualEvents.allKeys],
          filteredKeys: [...state.virtualEvents.allKeys]
        },
        filter: {
          ...state.filter,
          searchString: '',
          registrantRange: [MIN_RANGE, MAX_RANGE]
        }
      };
    }
    case Actions.TOGGLE_ALL_VIRTUAL_EVENTS: {
      const { deSelectedKeys, allKeys, filteredSelectedVirtualEventKeys } = state.virtualEvents;
      let newFilterSelectedVirtualEventKeys;
      let newDeSelectedKeys;
      if (action.payload.isSelected) {
        const sliceDeselectLength = MAX_VE_SELECTED - filteredSelectedVirtualEventKeys.length;
        newFilterSelectedVirtualEventKeys = [...filteredSelectedVirtualEventKeys].concat(
          deSelectedKeys.splice(0, sliceDeselectLength)
        );
        newDeSelectedKeys = [...deSelectedKeys];
      } else {
        newFilterSelectedVirtualEventKeys = [];
        newDeSelectedKeys = [...allKeys];
      }
      return {
        ...state,
        virtualEvents: {
          ...state.virtualEvents,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedVirtualEventKeys: newFilterSelectedVirtualEventKeys
        }
      };
    }
    case Actions.FILTER_VIRTUAL_EVENTS: {
      const {
        searchString = state.filter.searchString,
        registrantRange = state.filter.registrantRange
      } = action.payload;
      const { allKeys, byKey } = state.virtualEvents;
      const filteredKeys = getFilteredVirtualEventKeys(allKeys, byKey, searchString, registrantRange);
      return {
        ...state,
        virtualEvents: {
          ...state.virtualEvents,
          filteredKeys: filteredKeys
        },
        filter: {
          ...state.filter,
          searchString: searchString,
          registrantRange: registrantRange
        }
      };
    }
    default:
      return state;
  }
};

let getFilteredVirtualEventKeys = function(allVirtualEventKeys, virtualEventsMap, searchString, registrantRange) {
  const defaultRange = [MIN_RANGE, MAX_RANGE];
  if (isArrayEqual(registrantRange, defaultRange) && !searchString) {
    return [...allVirtualEventKeys];
  }
  return allVirtualEventKeys.filter(virtualEventKey => {
    const virtualEvent = virtualEventsMap[virtualEventKey] || {};
    const { registrantCount = 0, title } = virtualEvent;
    return (
      isInRange(registrantCount, registrantRange) &&
      (searchString && title ? title.toUpperCase().includes(searchString.toUpperCase()) : true)
    );
  });
};



// WEBPACK FOOTER //
// ./src/Reducks/VirtualEvents/VirtualEventsReducer.js